import React from "react";
import * as Icon from "react-bootstrap-icons";
import {Link, NavLink} from "react-router-dom";

export default function ExampleListing() {
    return (
    <main>
        <div className="row table-toolbar mb-3">
            <div className="col-6 align-self-center">
                <div className="h6 d-inline"><span className="text-warning">&#8226;</span> Users Management</div>
                <span className="ms-1">/</span> <span className="text-muted">Listing</span>
            </div>
            <div className="col-6 text-end align-self-center toolbars">
                <button type="button" className="btn btn-sm btn-primary"><Icon.PlusLg /> Add New</button>
                <button type="button" className="btn btn-sm btn-success ms-1"><Icon.FileExcel /> Export</button>
            </div>
        </div>
        <table className="table table-bordered">
            <thead>
                <tr>
                    <th className="w50 text-center">#</th>
                    <th>ชื่อผู้ใช้งาน</th>
                    <th>อีเมล</th>
                    <th className="text-center">เบอร์โทรศัพท์</th>
                    <th className="text-center">สิทธิ์</th>
                    <th className="w120 text-center">สถานะ</th>
                    <th className="w120 text-center">ลอกอินล่าสุด</th>
                    <th className="w100 text-center">เครื่องมือ</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>100</td>
                    <td>Surachart</td>
                    <td>Surachart.tow@gmail.com</td>
                    <td className="text-center">0899998888</td>
                    <td className="text-center">Administrator</td>
                    <td className="text-center">
                        <div className="form-check form-switch">
                            <input className="form-check-input float-none" type="checkbox" id="flexSwitchCheckChecked" checked />
                            <label className="form-check-label" htmlFor="flexSwitchCheckChecked"></label>
                        </div>
                    </td>
                    <td className="text-center">2022-06-10<span className="d-block small text-muted">12:30</span></td>
                    <td className="text-center">
                        <button type="button" className="btn btn-sm btn-light"><Icon.Pencil /></button>
                        <button type="button" className="btn btn-sm btn-light ms-2"><Icon.Trash /></button>
                    </td>
                </tr>
                <tr>
                    <td>100</td>
                    <td>Surachart</td>
                    <td>Surachart.tow@gmail.com</td>
                    <td className="text-center">0899998888</td>
                    <td className="text-center">Administrator</td>
                    <td className="text-center">
                        <div className="form-check form-switch">
                            <input className="form-check-input float-none" type="checkbox" id="flexSwitchCheckChecked2" />
                            <label className="form-check-label" htmlFor="flexSwitchCheckChecked2"></label>
                        </div>
                    </td>
                    <td className="text-center">2022-06-10<span className="d-block small text-muted">12:30</span></td>
                    <td className="text-center">
                        <button type="button" className="btn btn-sm btn-secondary"><Icon.Pencil /></button>
                        <button type="button" className="btn btn-sm btn-secondary ms-2"><Icon.Trash /></button>
                    </td>
                </tr>
                <tr>
                    <td>100</td>
                    <td>Surachart</td>
                    <td>Surachart.tow@gmail.com</td>
                    <td className="text-center">0899998888</td>
                    <td className="text-center">Administrator</td>
                    <td className="text-center">
                        <div className="form-check form-switch">
                            <input className="form-check-input float-none" type="checkbox" id="flexSwitchCheckChecked" checked />
                            <label className="form-check-label" htmlFor="flexSwitchCheckChecked"></label>
                        </div>
                    </td>
                    <td className="text-center">2022-06-10<span className="d-block small text-muted">12:30</span></td>
                    <td className="text-center">
                        <button type="button" className="btn btn-sm btn-light"><Icon.Pencil /></button>
                        <button type="button" className="btn btn-sm btn-light ms-2"><Icon.Trash /></button>
                    </td>
                </tr>
                <tr>
                    <td>100</td>
                    <td>Surachart</td>
                    <td>Surachart.tow@gmail.com</td>
                    <td className="text-center">0899998888</td>
                    <td className="text-center">Administrator</td>
                    <td className="text-center">
                        <div className="form-check form-switch">
                            <input className="form-check-input float-none" type="checkbox" id="flexSwitchCheckChecked" checked />
                            <label className="form-check-label" htmlFor="flexSwitchCheckChecked"></label>
                        </div>
                    </td>
                    <td className="text-center">2022-06-10<span className="d-block small text-muted">12:30</span></td>
                    <td className="text-center">
                        <button type="button" className="btn btn-sm btn-light"><Icon.Pencil /></button>
                        <button type="button" className="btn btn-sm btn-light ms-2"><Icon.Trash /></button>
                    </td>
                </tr>
                <tr>
                    <td>100</td>
                    <td>Surachart</td>
                    <td>Surachart.tow@gmail.com</td>
                    <td className="text-center">0899998888</td>
                    <td className="text-center">Administrator</td>
                    <td className="text-center">
                        <div className="form-check form-switch">
                            <input className="form-check-input float-none" type="checkbox" id="flexSwitchCheckChecked" checked />
                            <label className="form-check-label" htmlFor="flexSwitchCheckChecked"></label>
                        </div>
                    </td>
                    <td className="text-center">2022-06-10<span className="d-block small text-muted">12:30</span></td>
                    <td className="text-center">
                        <button type="button" className="btn btn-sm btn-light"><Icon.Pencil /></button>
                        <button type="button" className="btn btn-sm btn-light ms-2"><Icon.Trash /></button>
                    </td>
                </tr>
                <tr>
                    <td>100</td>
                    <td>Surachart</td>
                    <td>Surachart.tow@gmail.com</td>
                    <td className="text-center">0899998888</td>
                    <td className="text-center">Administrator</td>
                    <td className="text-center">
                        <div className="form-check form-switch">
                            <input className="form-check-input float-none" type="checkbox" id="flexSwitchCheckChecked" checked />
                            <label className="form-check-label" htmlFor="flexSwitchCheckChecked"></label>
                        </div>
                    </td>
                    <td className="text-center">2022-06-10<span className="d-block small text-muted">12:30</span></td>
                    <td className="text-center">
                        <button type="button" className="btn btn-sm btn-light"><Icon.Pencil /></button>
                        <button type="button" className="btn btn-sm btn-light ms-2"><Icon.Trash /></button>
                    </td>
                </tr>
                <tr>
                    <td>100</td>
                    <td>Surachart</td>
                    <td>Surachart.tow@gmail.com</td>
                    <td className="text-center">0899998888</td>
                    <td className="text-center">Administrator</td>
                    <td className="text-center">
                        <div className="form-check form-switch">
                            <input className="form-check-input float-none" type="checkbox" id="flexSwitchCheckChecked" checked />
                            <label className="form-check-label" htmlFor="flexSwitchCheckChecked"></label>
                        </div>
                    </td>
                    <td className="text-center">2022-06-10<span className="d-block small text-muted">12:30</span></td>
                    <td className="text-center">
                        <button type="button" className="btn btn-sm btn-light"><Icon.Pencil /></button>
                        <button type="button" className="btn btn-sm btn-light ms-2"><Icon.Trash /></button>
                    </td>
                </tr>
                <tr>
                    <td>100</td>
                    <td>Surachart</td>
                    <td>Surachart.tow@gmail.com</td>
                    <td className="text-center">0899998888</td>
                    <td className="text-center">Administrator</td>
                    <td className="text-center">
                        <div className="form-check form-switch">
                            <input className="form-check-input float-none" type="checkbox" id="flexSwitchCheckChecked" checked />
                            <label className="form-check-label" htmlFor="flexSwitchCheckChecked"></label>
                        </div>
                    </td>
                    <td className="text-center">2022-06-10<span className="d-block small text-muted">12:30</span></td>
                    <td className="text-center">
                        <button type="button" className="btn btn-sm btn-light"><Icon.Pencil /></button>
                        <button type="button" className="btn btn-sm btn-light ms-2"><Icon.Trash /></button>
                    </td>
                </tr>
            </tbody>
        </table>

        <nav aria-label="Page navigation example">
            <ul className="pagination justify-content-center">
                <li className="page-item">
                    <Link className="page-link" to='' aria-label="Previous">
                        <span aria-hidden="true">&laquo;</span>
                    </Link>
                </li>
                <li className="page-item"><Link className="page-link" to=''>1</Link></li>
                <li className="page-item active" aria-current="page">
                    <Link className="page-link" to=''>2</Link>
                </li>
                <li className="page-item"><Link className="page-link" to=''>3</Link></li>
                <li className="page-item"><Link className="page-link" to=''>4</Link></li>
                <li className="page-item"><Link className="page-link" to=''>5</Link></li>
                <li className="page-item"><Link className="page-link" to=''>6</Link></li>
                <li className="page-item"><Link className="page-link" to=''>7</Link></li>
                <li className="page-item">
                    <Link className="page-link" to='' aria-label="Next">
                        <span aria-hidden="true">&raquo;</span>
                    </Link>
                </li>
            </ul>
        </nav>
    </main>
    );
} 